// @ts-check

import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useIntl } from "react-intl";
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
//
// @ts-ignore
import isArray from "lodash/isArray";
// @ts-ignore
import isString from "lodash/isString";
import { useDispatch, useSelector } from "react-redux";
import SocietyNetwork from "./drawSnaLxt/SocietyNetwork";
import useResizeSnaDiv from "./useResizeSnaDiv";
import useRefDimensions from "../../../../../common/hooks/useRefDimensions";
//
import { StoreContext } from "../../../../../store/StoreProvider";
import Act from "../../../../../store/actions";

// config,utils
import {
  filterNetworkDataByEventType,
  isAllDatasetNotNull,
  onClickNode,
  onMouseOverNode,
  onMouseOutNode,
  onClickLink,
} from "./helper";
import {
  setErrorMessage,
  setInfoMessage,
} from "../../../../../reduxStore/commonSlice";
// style
import { placeNodeConfig } from "./drawSnaLxt/networkConfig";
import { combineDatasetChecked } from "./drawSnaLxt/drawNetwork/psDataUtil";
import { getISOString } from "../../../../../config/config.sna";
import { isTrue } from "../../../../../common/utils";
// eslint-disable-next-line import/named
import { SNA_DISPLAY_DIV_ID, SNA_WRAPPER_DIV_ID } from "../../../config";
import {
  deleteUserFile,
  getGroupDatasetSna,
  getPublicDataSna,
} from "../../../service/datasetService";
import { getPersonalDatasetSna } from "../../../service/settingService";

const StyledBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "calc(100vh - 64px - 48px - 50px - 20px)",
  borderRadius: "8px",
  boxShadow: "0 15px 30px 0 rgba(180, 189, 207, 0.3)",
  backgroundColor: "#fff",
}));

// eslint-disable-next-line prefer-destructuring
const width = window.innerWidth - 420;
// eslint-disable-next-line prefer-destructuring
const height = window.innerHeight - 200;

const DisplayArea = () => {
  // props

  // route,intl
  const intl = useIntl();
  // store
  const reduxDispatch = useDispatch();
  // @ts-ignore
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const {
    dataset,
    adjust,
    filter,
    applyFetchDataset,
    applyAdjustSetting,
    applyFilterSetting,
    sidebar,
    snaDisplay,
  } = sna;
  const {
    startEndDate,
    nodeCount,
    linkCount,
    limitTotalNodesCount,
    // nodeCountMeetAuth,
    nodeCountMeetAuthNew,
    filterEventTypeOn,
    eventTypes,
  } = filter || {};

  // local state
  const [networkData, setNetworkData] = useState([]);
  const [networkDataFiltered, setNetworkDataFiltered] = useState([]);
  const [snaColors, setSnaColors] = useState(adjust.nodeColors.initial);
  const [snaGroups, setSnaGroups] = useState([]);
  const [focusNodes, setFocusNodes] = useState([]); // 有聚焦的 nodes
  const [datasetSelect, setDatasetSelect] = useState([]);

  // 建立 ref 傳遞給 SocietyNetwork component 以取得 SNA 繪圖區, 便於匯出圖片
  const myRef = React.createRef();
  // todo: 建立 ref 抓取繪圖區外的 box 邊界
  const myRef2 = React.createRef();
  // 一開始 myRef.current 為 null, 所以會先取 width 當snaWidth預設值
  const [snaWidth, setSnaWidth] = useState(
    myRef?.current?.offsetWidth || width
  );
  // 一開始 myRef.current 為 null, 所以會先取 height 當snaHeight預設值
  const [snaHeight, setSnaHeight] = useState(
    myRef?.current?.offsetHeight || height
  );
  const myRef2WidthHeight = useRefDimensions(myRef2);

  // handle sna div size change
  const resizeResult = useResizeSnaDiv({
    sidebarOpen: sidebar.open,
    defaultHeight: height,
    defaultWidth: width,
    setSnaHeight,
    setSnaWidth,
    snaDivId: SNA_DISPLAY_DIV_ID,
  });

  // 偵測 sna wrapper 的 width,height 變動,當作 拖曳視窗的邊界
  useEffect(() => {
    dispatch({
      type: Act.SNA_DISPLAY_MEMO_WIDTH,
      payload: myRef2WidthHeight.width,
    });
    dispatch({
      type: Act.SNA_DISPLAY_MEMO_HEIGHT,
      payload: myRef2WidthHeight.height,
    });
  }, [myRef2WidthHeight.width, myRef2WidthHeight.height]);

  const getAllData = async () => {
    // fixme: 暫時不要 fetch API,增加開發速度
    const block = false;
    try {
      // dataset: {
      //   group: [], // 團隊的資料集 [{id:"",displayName:"",...}]
      //   personal: [], // 個人的資料集
      //   select: [], // 選定的資料集
      // }
      // fixme: 暫時不要 fetch API,增加開發速度
      if (block) return;
      const authorRemoveIds = (filter?.nodeAuthorPreserve?.initial || [])
        .filter(
          // @ts-ignore
          (item) => !item.checked
        )
        .map(
          // @ts-ignore
          (item) => item.authorId
        );

      const startDate = getISOString(startEndDate.initial[0]);
      const endDate = getISOString(startEndDate.initial[1]);
      const apiParams = { startDate, endDate };
      const publicData = await getPublicDataSna(
        dataset.public,
        apiParams,
        authorRemoveIds
      );
      const groupData = await getGroupDatasetSna(dataset.group);
      const personalData = await getPersonalDatasetSna(dataset.personal);

      /**
       *
       * @type {*[]}
       */
      const errors = [];
      [publicData, groupData, personalData].forEach((item) => {
        if (item.error) {
          errors.push(item.error);
        }
      });
      if (errors.length > 0) {
        dispatch({
          type: Act.COMMON_SET_ERROR_MESSAGE,
          payload: {
            open: true,
            content: errors.join(";"),
          },
        });
      }
      const allData = [
        ...publicData.data,
        ...groupData.data,
        ...personalData.data,
      ];
      // @ts-ignore
      setNetworkData(allData);

      let tmpDataFiltered;
      if (filterEventTypeOn.initial) {
        tmpDataFiltered = filterNetworkDataByEventType(
          allData,
          eventTypes.initial
        );
      } else {
        tmpDataFiltered = allData;
      }
      // @ts-ignore
      setNetworkDataFiltered(tmpDataFiltered);
      dispatch({
        type: Act.SNA_DIARY_INFO_EVENT_LIST,
        payload: tmpDataFiltered,
      });
    } catch (err) {
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          // @ts-ignore
          content: err.message,
        },
      });
    } finally {
      // 停止搜尋
      dispatch({
        type: Act.SNA_APPLY_FETCH_DATASET,
        payload: false,
      });
    }
  };

  useEffect(() => {
    if (applyFetchDataset && isAllDatasetNotNull(dataset)) {
      // loader
      dispatch({
        type: Act.COMMON_SET_LOADER,
        payload: {
          open: true,
        },
      });
      // 取得各類別的資料: public, group, personal
      getAllData();
      // 把 dataset 中各類別中有 checked 的資料集整合成一個 list
      setSnaGroups(
        // @ts-ignore
        combineDatasetChecked(dataset, ["public", "group", "personal"]).map(
          (item) => ({ ...item, label: item.name || item.displayName })
        )
      );
    } else {
      // loader
      dispatch({
        type: Act.COMMON_SET_LOADER,
        payload: {
          open: false,
        },
      });
    }
  }, [
    applyFetchDataset,
    dataset,
    filter.nodeAuthorPreserve.change,
    // filter.limitTotalNodesCount.change,
  ]);

  // 依據使用者的 adjust 設定, 調整 snaData
  useEffect(() => {
    if (applyAdjustSetting && adjust.nodeColors.initial.length > 0) {
      setSnaColors(adjust.nodeColors.initial);
      dispatch({
        type: Act.SNA_APPLY_ADJUST_SETTING,
        payload: false,
      });
    }
  }, [adjust, applyAdjustSetting]);

  // 依據使用者的 filter 設定, 調整 snaData
  useEffect(() => {
    if (applyFilterSetting) {
      dispatch({
        type: Act.SNA_APPLY_FILTER_SETTING,
        payload: false,
      });
      // 過濾事件
      let tmpDataFiltered;
      if (filterEventTypeOn.initial) {
        tmpDataFiltered = filterNetworkDataByEventType(
          networkData,
          eventTypes.initial
        );
      } else {
        tmpDataFiltered = networkData;
      }
      // @ts-ignore
      setNetworkDataFiltered(tmpDataFiltered);
      dispatch({
        type: Act.SNA_DIARY_INFO_EVENT_LIST,
        payload: tmpDataFiltered,
      });
    }
  }, [filter, eventTypes, applyFilterSetting, filterEventTypeOn]);

  useEffect(() => {
    // 當 sna 的資料變動時,要清空 focusNodes
    setFocusNodes([]);
  }, [networkDataFiltered]);

  useEffect(() => {
    // local 的 focusNodes 狀態變更時,更新狀態到 store
    if (isArray(focusNodes)) {
      dispatch({
        type: Act.SNA_DISPLAY_FOCUS_NODES,
        payload: focusNodes,
      });
    }
  }, [focusNodes]);

  useEffect(() => {
    const newDatasetSelect = Object.entries(dataset).reduce(
      (acc, [key, list]) => {
        if (key === "select") return acc;
        (list || []).forEach((file) => {
          if (file.checked) {
            acc.push({ ...file, datasetType: key });
          }
        });
        return acc;
      },
      []
    );
    setDatasetSelect(newDatasetSelect);
  }, [dataset]);

  return (
    <StyledBox ref={myRef2} id={SNA_WRAPPER_DIV_ID}>
      <Box textAlign="center">
        {/* @ts-ignore */}
        <SocietyNetwork
          // @ts-ignore
          maxLinks={Number.parseInt(linkCount.initial, 10)}
          maxNodes={Number.parseInt(nodeCount.initial, 10)}
          limitTotalNodesCount={Number.parseInt(
            limitTotalNodesCount.initial,
            10
          )}
          data={networkDataFiltered}
          // @ts-ignore
          group={snaGroups.map((s) => s.label)}
          addNodeCount={isTrue(adjust?.nodeShowNodeCount?.initial)}
          placeNodeMode={adjust?.nodePlaceMode?.initial}
          placeNodeConfig={placeNodeConfig}
          statisticDispersion={Number.parseInt(
            adjust?.nodeDispersion?.initial,
            10
          )}
          colors={snaColors}
          legendShowNodDataGroup={isTrue(
            adjust?.legendShowNodDataGroup?.initial
          )}
          // nodeCountMeetAuth={nodeCountMeetAuth?.initial}
          nodeCountMeetAuthNew={nodeCountMeetAuthNew?.initial}
          // @ts-ignore
          onGroupNetworkDataReady={(data) =>
            dispatch({
              type: Act.SNA_DISPLAY_DRAW_NETWORK_DATA,
              payload: { ...data },
            })
          }
          myRef={myRef}
          sidebarOpen={sidebar.open}
          snaWidth={snaWidth}
          snaHeight={snaHeight}
          snaDivId={SNA_DISPLAY_DIV_ID}
          onClickNode={onClickNode(focusNodes, setFocusNodes)}
          onMouseOverNode={onMouseOverNode(state, dispatch)}
          onMouseOutNode={onMouseOutNode(state, dispatch)}
          onClickLink={onClickLink(state, dispatch)}
          // @ts-ignore
          alertCallback={(msg) => {
            reduxDispatch(
              setInfoMessage({
                open: true,
                content: isString(msg) ? msg : JSON.stringify(msg),
                duration: 6000,
              })
            );
          }}
          datasetTotal={datasetSelect.length}
        />
      </Box>
    </StyledBox>
  );
};

DisplayArea.propTypes = {};

DisplayArea.defaultProps = {};

export default DisplayArea;
